const cardItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20film%20poster%20aesthetic%20with%20warm%20amber%20lighting%20and%20emotional%20atmosphere%2C%20elegant%20composition%20with%20soft%20shadows%2C%20film%20photography%20style%2C%20dark%20moody%20background%2C%20no%20text%20or%20people&width=600&height=400&seq=card-01-6080&orientation=landscape',
    tag: '豆瓣高分',
    title: '评分9.0+经典电影合集',
    desc: '精选百部豆瓣高分佳作，每一部都是影史经典，值得反复品味。',
    heat: '128万播放',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20cinematic%20scene%20with%20muted%20teal%20and%20warm%20tone%2C%20contemporary%20setting%20with%20soft%20natural%20light%2C%20film%20grain%20texture%2C%20professional%20cinematography%2C%20no%20text%20or%20people&width=600&height=400&seq=card-02-6080&orientation=landscape',
    tag: '热播剧集',
    title: '2026暑期档必追国产剧',
    desc: '今夏最火爆的国产电视剧全收录，高清不卡顿全集免费在线观看。',
    heat: '256万播放',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Action%20thriller%20cinematic%20atmosphere%20with%20dynamic%20energy%20and%20dramatic%20dark%20lighting%2C%20intense%20mood%20with%20amber%20highlights%2C%20professional%20film%20photography%2C%20no%20text%20or%20people&width=600&height=400&seq=card-03-6080&orientation=landscape',
    tag: '新片速递',
    title: '最新上映院线大片速看',
    desc: '院线热映大片极速上线，不缓冲秒开，第一时间享受影院级观影。',
    heat: '189万播放',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20classic%20film%20aesthetic%20with%20vintage%20warm%20tones%20and%20soft%20golden%20light%2C%20old%20cinema%20atmosphere%2C%20film%20grain%20and%20texture%2C%20elegant%20composition%2C%20no%20text%20or%20people&width=600&height=400&seq=card-04-6080&orientation=landscape',
    tag: '经典怀旧',
    title: '8090年代港片黄金时代',
    desc: '重温香港电影黄金年代的经典之作，成龙、周星驰、周润发全收录。',
    heat: '95万播放',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20cinematic%20style%20with%20romantic%20soft%20lighting%20and%20warm%20pastel%20tones%2C%20elegant%20Korean%20aesthetic%2C%20emotional%20atmosphere%2C%20professional%20cinematography%2C%20no%20text%20or%20people&width=600&height=400&seq=card-05-6080&orientation=landscape',
    tag: '韩剧精选',
    title: '2026热门韩剧追更日历',
    desc: '最新韩剧同步更新，高清中文字幕，全集不卡顿流畅播放体验。',
    heat: '312万播放',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Animated%20film%20cinematic%20scene%20with%20vibrant%20colors%20and%20magical%20atmosphere%2C%20whimsical%20lighting%20with%20golden%20particles%2C%20dreamy%20fantasy%20mood%2C%20high%20quality%20animation%20style%2C%20no%20text%20or%20people&width=600&height=400&seq=card-06-6080&orientation=landscape',
    tag: '亲子时光',
    title: '适合全家观看的动画电影',
    desc: '精选优质动画电影，寓教于乐，亲子观影的绝佳选择，让孩子开心家长放心。',
    heat: '67万播放',
  },
];

const topicItems = [
  { label: '暑期档电影', heat: '火热' },
  { label: '不缓冲秒开', heat: '推荐' },
  { label: '国产剧推荐', heat: '热门' },
  { label: '悬疑烧脑', heat: '上升' },
  { label: '高清蓝光', heat: '推荐' },
  { label: '韩剧追更', heat: '火爆' },
  { label: '免费影视大全', heat: '热门' },
  { label: '动作大片', heat: '火热' },
  { label: '全集在线看', heat: '推荐' },
  { label: '经典重温', heat: '上升' },
  { label: '新片速递', heat: '火爆' },
];

export default function CardsTopicsSection() {
  return (
    <>
      <section id="cards" className="relative w-full py-16 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              热播推荐
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              编辑精选六大王牌片单，高清电影电视剧免费在线观看
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {cardItems.map((item, idx) => (
              <div
                key={idx}
                className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/40 hover:border-primary-500/20 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full aspect-[3/2] overflow-hidden">
                  <img
                    src={item.image}
                    alt={`6080新视觉影院 ${item.tag} - ${item.title}`}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 text-xs font-medium bg-accent-500/80 text-foreground-950 rounded-full whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <div className="absolute bottom-3 right-3">
                    <span className="px-2 py-0.5 text-[10px] bg-background-50/80 backdrop-blur-sm text-foreground-500 rounded-full">
                      {item.heat}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-800 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="topics" className="relative w-full py-16 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              热门话题
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              当下最受关注的高清影视话题，看看大家都在讨论什么
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-3">
            {topicItems.map((item, idx) => (
              <span
                key={idx}
                className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-100 rounded-full border border-background-200/40 hover:border-primary-500/20 hover:bg-background-200/60 transition-all duration-200 cursor-pointer"
              >
                <span className="text-sm text-foreground-700 whitespace-nowrap">{item.label}</span>
                <span className={`text-[10px] font-medium px-1.5 py-0.5 rounded-full whitespace-nowrap ${
                  item.heat === '火爆' ? 'bg-accent-500/15 text-accent-400' :
                  item.heat === '火热' ? 'bg-primary-500/15 text-primary-400' :
                  item.heat === '热门' ? 'bg-primary-500/10 text-primary-400' :
                  item.heat === '上升' ? 'bg-secondary-500/10 text-secondary-400' :
                  'bg-secondary-500/10 text-secondary-400'
                }`}>
                  {item.heat}
                </span>
              </span>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}